import { Link as RouterLink } from "react-router-dom";
import { BasePage } from 'components';
import { Grid, Box, Typography, Button } from '@mui/material';

export function NotFoundPage() {
    return (
        <BasePage>
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center' 
                }}
            >
                <Grid 
                    container 
                    spacing={3} 
                    justifyContent="center" 
                    alignItems="center" 
                    direction="column"
                    sx={{ textAlign: 'center', maxWidth: 400 }}
                >
                    <Grid>
                        <Typography variant="h6">
                            Page not found
                        </Typography>
                        <Typography variant="body1">
                            Sorry, the page you're looking for doesn't exist.
                        </Typography>
                    </Grid>
                    
                    <Grid sx={{ mt: 3 }}>
                        <Button
                            component={RouterLink}
                            to="/"
                            variant="contained"
                            size="large"
                            sx={{ minWidth: 120 }}
                        >
                            Go home
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </BasePage>
    )
}